import script from "./ButtonLink.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonLink.vue?vue&type=script&setup=true&lang=js"

import "./ButtonLink.vue?vue&type=style&index=0&id=ed2819de&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed2819de"]])

export default __exports__